import { create } from 'zustand'

export type RecurrencePeriod = 1 | 3 | 6 | 12
export type PaymentMethod = 'pix' | 'credit_card' | 'boleto'

export type AddressData = {
  cep: string
  street: string
  number: string
  complement: string
  neighborhood: string
  city: string
  state: string
}

export type CustomerData = {
  name: string
  cpf: string
  phone: string
  address: AddressData
}

type CheckoutStore = {
  customer: CustomerData
  recurrence: RecurrencePeriod
  paymentMethod: PaymentMethod | null
  orderId: string | null

  setCustomerField: <K extends keyof CustomerData>(field: K, value: CustomerData[K]) => void
  setAddressField: <K extends keyof AddressData>(field: K, value: AddressData[K]) => void
  setRecurrence: (r: RecurrencePeriod) => void
  setPaymentMethod: (method: PaymentMethod) => void
  setOrderId: (id: string) => void
  resetCheckout: () => void
}

const emptyAddress: AddressData = {
  cep: '',
  street: '',
  number: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: '',
}

const emptyCustomer: CustomerData = {
  name: '',
  cpf: '',
  phone: '',
  address: { ...emptyAddress },
}

export const useCheckoutStore = create<CheckoutStore>((set) => ({
  customer: { ...emptyCustomer, address: { ...emptyAddress } },
  recurrence: 3,
  paymentMethod: null,
  orderId: null,

  setCustomerField: (field, value) => set((s) => ({ customer: { ...s.customer, [field]: value } })),
  setAddressField: (field, value) =>
    set((s) => ({
      customer: {
        ...s.customer,
        address: { ...s.customer.address, [field]: value },
      },
    })),
  setRecurrence: (recurrence) => set({ recurrence }),
  setPaymentMethod: (paymentMethod) => set({ paymentMethod }),
  setOrderId: (orderId) => set({ orderId }),
  resetCheckout: () =>
    set({
      customer: { ...emptyCustomer, address: { ...emptyAddress } },
      recurrence: 3,
      paymentMethod: null,
      orderId: null,
    }),
}))
